<script setup lang="ts">
import SIcon from '@/components/SIcon.vue';
import SButton from '@/components/SButton/SButton.vue';
import SHtmlView from '@/components/SHtmlView/SHtmlView.vue';

const iconMap = {
  info: 'icon-info-circle-fill',
  error: 'icon-dismiss-circle-fill',
  warning: 'icon-warning-fill',
  success: 'icon-check-circle-fill',
  ai: 'icon-sparkles',
};

const iconColorMap = {
  // those are not the right colors, fix later
  info: 'iconNeutral',
  error: 'iconDanger',
  warning: 'iconWarning',
  success: 'iconSuccess',
  ai: 'iconAi',
};

const getIcon = (type: string) => iconMap[type as keyof typeof iconMap];

const iconColor = (type: string) => iconColorMap[type as keyof typeof iconColorMap] || iconColorMap.info;

</script>

<template>
  <notifications
    width="400"
    :duration="5000"
    position="bottom center">
    <template #body="{ item, close }">
      <v-card
        outlined
        :class="`s-notification-card--${item.type || 'success'}`"
        class="s-notification d-flex elevation-2 ma-3 py-2 pr-4 pl-2"
      >
        <div class="s-notification-background"></div>

        <div class="icon ml-1 mr-3 d-flex align-start justify-center">
          <SIcon :color="iconColor(item.type || 'success')" :icon="getIcon(item.type || 'success')" />
        </div>

        <div class="d-flex flex-column mt-0 mr-6">
          <span class="font-weight-medium mb-1">
            {{ item.title }}
          </span>
          <div style="z-index: 1">
            <SHtmlView
              :html="item.text"
              class="text-caption text-break"
            />
          </div>
        </div>

        <SButton
          class="s-notification--close-btn"
          size="x-small"
          icon="icon-dismiss-medium"
          color="secondary"
          variant="text"
          @click="close"
        >
          <v-icon class="font-weight-medium" small>icon-dismiss</v-icon>
        </SButton>
      </v-card>
    </template>
  </notifications>
</template>

<style lang="scss" scoped>
.s-notification {
  overflow: auto;
  position: relative;
  background: themeColor('bg_secondary');
  border-left: 8px solid;

  &-card {
    &--info {
      background-color: var(--v-bgPrimary-base);
      border-color: var(--v-borderPrimary-base);
    }

    &--success {
      // bgSuccessPrimary
      background-color: var(--v-bgSuccessPrimary-base);
      border-color: var(--v-borderSuccess-base);
    }

    &--error {
      background-color: var(--v-bgDangerPrimary-base);
      border-color: var(--v-borderDanger-base);
    }

    &--warning {
      background-color: var(--v-bgWarningPrimary-base);
      border-color: var(--v-borderWarning-base);
    }

    &--ai {
      background-color: var(--v-bgAiPrimary-base);
      border-color: var(--v-borderAi-base);
    }

  }

  &--close-btn {
    position: absolute;
    top: 4px;
    right: 10px;
  }

  &--link {
    color: themeColor('text_accent');
    text-decoration: none;
  }

  :deep(.s-notification--link) {
    color: themeColor('text_accent');
    text-decoration: none;

    &:hover {
      color: themeColor('text_accent_hover');
      text-decoration: underline;
    }

  }
}
</style>
